module.exports = __webpack_public_path__ + "img/FollowUpBoss.813cc7c1.png";